<script setup>
import usePublicStore from "@/store/public";
import { storeToRefs } from "pinia";
import { useValidacionCelular } from "@/composables/usePublic";
import CotizacionCodigo from "@/modules/public/pages/cotizacion/components/CotizacionCodigo";

const { globalPhone, Close, state } = storeToRefs(usePublicStore());
const { sendSMS, btnLoading } = useValidacionCelular();
const { fetchInitPublicCotizacionData } = usePublicStore();

fetchInitPublicCotizacionData();
</script>

<template>
  <div class="col-md-6 col-lg-4 mx-auto mt-6">
    <form id="formCelular" @submit.prevent="sendSMS">
      <div class="d-flex justify-content-center mb-3">
        <label
          for="correo"
          class="col-sm-5 col-form-label text-end pe-3 text-dark"
          >Correo <span class="d-none d-md-inline">electrónico</span></label
        >
        <div class="col-sm-7">
          <input
            type="email"
            name="correo"
            class="form-control"
            id="correo"
            placeholder="Ingresa tu correo electrónico aquí"
            required
            autocomplete="off"
            v-model="state.correo"
          />
        </div>
      </div>
      <div class="d-flex justify-content-center mb-3">
        <label
          for="celular"
          class="col-sm-5 col-form-label text-end pe-3 text-dark"
          >Celular</label
        >
        <div class="col-sm-7">
          <input
            type="tel"
            class="form-control"
            id="celular"
            placeholder="Ingresa tu de número celular aquí"
            required
            name="celular"
            autocomplete="off"
            v-model="state.celular"
          />
        </div>
      </div>
      <div class="text-center my-4 mt-5">
        <button
          type="submit"
          class="btn bg-dark text-white px-5 py-2 rounded-pill shadow-none fw-light"
          :disabled="btnLoading"
        >
          <span
            class="spinner-border spinner-border-sm me-1"
            role="status"
            aria-hidden="true"
            v-show="btnLoading"
          ></span>
          Siguiente paso
        </button>
      </div>
    </form>
  </div>
  <div
    class="text-center bg-dark p-4 col-md-9 mx-auto shadow-xl mb-6"
    style="border-radius: 60px"
  >
    <div>
      <h5 class="fw-light text-white">
        Si necesitas ayuda, escríbenos por Whatsapp<br />
        para resulver tus dudas o agendar una llamada.
      </h5>
      <a href="https://api.whatsapp.com/send/?phone=%2B528715060593&text&type=phone_number&app_absent=0" target="_blank" class="btn btn-warning rounded-pill text-dark btn-lg mt-3">
        <span>Contacta un asesor</span>
      </a>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade border-3 bg-white"
    id="modalCodigo"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered rounded-3">
      <div class="modal-content bg-light">
        <div class="modal-header border-0 d-flex flex-row justify-content-end">
          <button
            type="button"
            class="p-4 text-black border-0"
            data-bs-dismiss="modal"
            ref="Close"
          >
            <i class="fa">X</i>
          </button>
        </div>
        <div class="modal-body text-center rounded-3">
          <div class="container pt-3 pb-6">
            <CotizacionCodigo />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
